import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

export default register('testimonial-carousel', {
  onLoad() {
    // eslint-disable no-unused-vars
    const thisPreviousButton = this.container.querySelector('.btn--control-prev');
    const thisNextButton = this.container.querySelector('.btn--control-next');
    const carouselStatus = this.container.querySelector('.carousel-status');

    const thisSlider = new Flickity('.testimonial-carousel', {
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      setGallerySize: true,
      on: {
        ready() {
          if (!thisPreviousButton) return;
          if (thisPreviousButton) {
            thisPreviousButton.addEventListener('click', function () {
              thisSlider.previous();
            });
            thisNextButton.addEventListener('click', function () {
              thisSlider.next();
            });
          }
        },
        change() {
          if (!thisSlider.slides[thisSlider.selectedIndex - 1]) {
            thisPreviousButton.setAttribute('disabled', 'disabled');
            thisNextButton.removeAttribute('disabled');
            // eslint-disable-next-line no-negated-condition
          } else if (!thisSlider.slides[thisSlider.selectedIndex + 1]) {
            thisPreviousButton.removeAttribute('disabled');
            thisNextButton.setAttribute('disabled', 'disabled');
          } else {
            thisPreviousButton.removeAttribute('disabled');
            thisNextButton.removeAttribute('disabled');
          }

          const slideNumber = thisSlider.selectedIndex + 1;
          carouselStatus.textContent = `0${slideNumber} / ${thisSlider.slides.length < 10 ? '0' : ''}${
            thisSlider.slides.length
          }`;
        },
      },
    });
  },
});
